module.exports = __webpack_public_path__ + "img/s8lModel.2dd91c10.webp";